export class CaseManWorklistRequest{
    type:string;
    center:string;

    constructor(type:string,center:string){
        this.type = type;
        this.center = center;
    }
}